import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../setup";

export const telegramApi = createApi({
  reducerPath: "telegramApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    start: builder.mutation({
      query: () => ({ url: `auth/telegram/start`, method: "POST" }),
    }),
    verify: builder.mutation({
      query: ({ start_token, otp }) => ({
        url: `auth/telegram/verify`,
        method: "POST",
        body: { start_token, otp },
      }),
    }),
    resend: builder.mutation({
      query: ({ start_token }) => ({
        url: `auth/telegram/resend`,
        method: "POST",
        body: { start_token },
      }),
    }),
    status: builder.query({
      query: (start_token) => ({
        url: `auth/telegram/status`,
        method: "GET",
        params: { start_token },
      }),
    }),
    notifyStart: builder.mutation({
      query: ({ subdomain } = {}) => ({
        url: `notify/telegram/start`,
        method: "POST",
        body: { subdomain },
      }),
    }),
    notifyVerify: builder.mutation({
      query: ({ start_token, startToken, otp }) => ({
        url: `notify/telegram/verify`,
        method: "POST",
        body: { startToken: startToken || start_token, otp },
      }),
    }),
    notifyResend: builder.mutation({
      query: ({ start_token, startToken }) => ({
        url: `notify/telegram/resend`,
        method: "POST",
        body: { startToken: startToken || start_token },
      }),
    }),
  }),
});

export const {
  useStartMutation: useStartTelegramMutation,
  useVerifyMutation: useVerifyTelegramMutation,
  useResendMutation: useResendTelegramMutation,
  useLazyStatusQuery: useLazyTelegramStatusQuery,
  useNotifyStartMutation,
  useNotifyVerifyMutation,
  useNotifyResendMutation,
} = telegramApi;
